import { render } from "./ServiceView.vue?vue&type=template&id=a7004cc6&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"

import "./ServiceView.vue?vue&type=style&index=0&id=a7004cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7004cc6"]])

export default __exports__